export default __webpack_public_path__ + "static/media/Gloves of the Oxmal.c679d5b4.jpg";